import { CloseIcon } from "@fla/components";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
import { FC, Fragment, ReactNode } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  showCloseIcon?: boolean;
  classes?: string;
  widthCSS?: string;
}

export const Modal: FC<Props> = ({ isOpen, onClose, children, showCloseIcon = true, classes, widthCSS }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[999]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-100 bg-opacity-75" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  "max-h-[90vh] transform overflow-hidden rounded-lg bg-white text-left align-middle shadow-xl transition-all",
                  {
                    "w-full md:max-w-xl 2xl:max-w-2xl": !widthCSS,
                    [`${widthCSS}`]: !!widthCSS
                  }
                )}
              >
                {showCloseIcon ? (
                  <div className="w-full h-12 px-4 flex justify-end items-center">
                    <button
                      className="focus:outline-none rounded-full w-8 h-8 flex items-center justify-center p-0.5 group"
                      onClick={onClose}
                      key="closeButton"
                    >
                      <CloseIcon classes="text-gray-300 group-hover:text-gray-600" />
                    </button>
                  </div>
                ) : null}
                <div
                  className={`px-4 pb-4 md:px-6 md:pb-6 h-[calc(100%_-_48px)] overflow-y-auto ${classes}`}
                  id="scrollableDiv"
                >
                  {children}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
